/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Loading_TitleInputs */

const es_toast_loading_title = /** @type {(inputs: Toast_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando`)
};

const en_toast_loading_title = /** @type {(inputs: Toast_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Toast_Loading_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const toast_loading_title = /** @type {((inputs?: Toast_Loading_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Loading_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_loading_title(inputs)
	return en_toast_loading_title(inputs)
});
export { toast_loading_title as "toast.loading_title" }